module.exports = __webpack_public_path__ + "6d8847a93ee6c43f0cd3fc8443657560.svg";